<template>
  <div class="filter-button-distance-wrapper">
    <b-dropdown
      class="search-types-dropdown radial-distance-dropdown"
      :disabled="disabled"
      no-caret
      title="Distance"
    >
      <template #button-content>
        <span class="d-sm-inline">
          {{ selectedRadius.name }}
        </span>
        <font-awesome-icon class="right-icon radial-distance-dropdown--chevron" :icon="['far', 'chevron-down']"/>
      </template>
      <b-dropdown-item-button
        v-for="(option, optionIndex) in radiusOtions"
        :key="optionIndex"
        class="radial-distance-dropdown--button"
        :active="selectedRadius.value === option.value"
        @click="changeRadius(option)"
      >
        {{ option.name }}
      </b-dropdown-item-button>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterButtonDistance',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('location', [
      'radiusOtions',
      'selectedRadius',
    ]),
  },

  methods: {
    ...mapActions('location', [
      'selectRadiusAndGetBounds',
    ]),

    changeRadius(radius) {
      this.selectRadiusAndGetBounds(radius)
    },
  },
}
</script>

<style lang="scss">
.filter-button-distance-wrapper {
  .radial-distance-dropdown {
    position: initial;
    overflow: hidden;

    > button {
      background-color: $color-yellow-bright;
      border-radius: 4px;
      border: 1px solid rgba(28, 36, 51, 0.20);
    }

    &.show {
      > .btn-secondary.dropdown-toggle {
        color: inherit !important;
        background-color: $color-yellow-lighter;
        border: 1px solid rgba(28, 36, 51, 0.20);
      }
    }

    > ul {
      top: 26px !important;
    }

    &--chevron {
      font-size: 12px;
    }
  }
}
</style>
